module.exports = __webpack_public_path__ + "static/media/typeScript.3de182d2.svg";